export const DIALOG_TYPES = {
  INFO: 'INFO',
  CONFIRMATION: 'CONFIRMATION',
  CUSTOM: 'CUSTOM',
};
